/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnimaticAlarmHornStrobeConfig,
  AnimaticAlarmHornStrobeConfig$inboundSchema,
  AnimaticAlarmHornStrobeConfig$Outbound,
  AnimaticAlarmHornStrobeConfig$outboundSchema,
} from "./animaticalarmhornstrobeconfig.js";
import {
  AnimaticCondenserConfig,
  AnimaticCondenserConfig$inboundSchema,
  AnimaticCondenserConfig$Outbound,
  AnimaticCondenserConfig$outboundSchema,
} from "./animaticcondenserconfig.js";
import {
  AnimaticControlValveConfig,
  AnimaticControlValveConfig$inboundSchema,
  AnimaticControlValveConfig$Outbound,
  AnimaticControlValveConfig$outboundSchema,
} from "./animaticcontrolvalveconfig.js";
import {
  AnimaticElectricUnderfloorHeaterConfig,
  AnimaticElectricUnderfloorHeaterConfig$inboundSchema,
  AnimaticElectricUnderfloorHeaterConfig$Outbound,
  AnimaticElectricUnderfloorHeaterConfig$outboundSchema,
} from "./animaticelectricunderfloorheaterconfig.js";
import {
  AnimaticEvaporatorConfig,
  AnimaticEvaporatorConfig$inboundSchema,
  AnimaticEvaporatorConfig$Outbound,
  AnimaticEvaporatorConfig$outboundSchema,
} from "./animaticevaporatorconfig.js";
import {
  AnimaticExhaustFanConfig,
  AnimaticExhaustFanConfig$inboundSchema,
  AnimaticExhaustFanConfig$Outbound,
  AnimaticExhaustFanConfig$outboundSchema,
} from "./animaticexhaustfanconfig.js";
import {
  AnimaticGasSensorConfig,
  AnimaticGasSensorConfig$inboundSchema,
  AnimaticGasSensorConfig$Outbound,
  AnimaticGasSensorConfig$outboundSchema,
} from "./animaticgassensorconfig.js";
import {
  AnimaticHeatExchangerConfig,
  AnimaticHeatExchangerConfig$inboundSchema,
  AnimaticHeatExchangerConfig$Outbound,
  AnimaticHeatExchangerConfig$outboundSchema,
} from "./animaticheatexchangerconfig.js";
import {
  AnimaticLTUConfig,
  AnimaticLTUConfig$inboundSchema,
  AnimaticLTUConfig$Outbound,
  AnimaticLTUConfig$outboundSchema,
} from "./animaticltuconfig.js";
import {
  AnimaticMixingTankConfig,
  AnimaticMixingTankConfig$inboundSchema,
  AnimaticMixingTankConfig$Outbound,
  AnimaticMixingTankConfig$outboundSchema,
} from "./animaticmixingtankconfig.js";
import {
  AnimaticPenthouseConfig,
  AnimaticPenthouseConfig$inboundSchema,
  AnimaticPenthouseConfig$Outbound,
  AnimaticPenthouseConfig$outboundSchema,
} from "./animaticpenthouseconfig.js";
import {
  AnimaticPumpConfig,
  AnimaticPumpConfig$inboundSchema,
  AnimaticPumpConfig$Outbound,
  AnimaticPumpConfig$outboundSchema,
} from "./animaticpumpconfig.js";
import {
  AnimaticRecipCompressorConfig,
  AnimaticRecipCompressorConfig$inboundSchema,
  AnimaticRecipCompressorConfig$Outbound,
  AnimaticRecipCompressorConfig$outboundSchema,
} from "./animaticrecipcompressorconfig.js";
import {
  AnimaticRemoteSumpConfig,
  AnimaticRemoteSumpConfig$inboundSchema,
  AnimaticRemoteSumpConfig$Outbound,
  AnimaticRemoteSumpConfig$outboundSchema,
} from "./animaticremotesumpconfig.js";
import {
  AnimaticReverseOsmosisConfig,
  AnimaticReverseOsmosisConfig$inboundSchema,
  AnimaticReverseOsmosisConfig$Outbound,
  AnimaticReverseOsmosisConfig$outboundSchema,
} from "./animaticreverseosmosisconfig.js";
import {
  AnimaticScrewCompressorConfig,
  AnimaticScrewCompressorConfig$inboundSchema,
  AnimaticScrewCompressorConfig$Outbound,
  AnimaticScrewCompressorConfig$outboundSchema,
} from "./animaticscrewcompressorconfig.js";
import {
  AnimaticVentilationStackConfig,
  AnimaticVentilationStackConfig$inboundSchema,
  AnimaticVentilationStackConfig$Outbound,
  AnimaticVentilationStackConfig$outboundSchema,
} from "./animaticventilationstackconfig.js";
import {
  AnimaticVesselConfig,
  AnimaticVesselConfig$inboundSchema,
  AnimaticVesselConfig$Outbound,
  AnimaticVesselConfig$outboundSchema,
} from "./animaticvesselconfig.js";
import {
  AnimaticWaterBathConfig,
  AnimaticWaterBathConfig$inboundSchema,
  AnimaticWaterBathConfig$Outbound,
  AnimaticWaterBathConfig$outboundSchema,
} from "./animaticwaterbathconfig.js";

/**
 * A configuration for a specific animatic.
 */
export type SpecificAnimaticConfig = {
  /**
   * The configuration of the animatic for an alarm horn strobe.
   */
  alarmHornStrobe?: AnimaticAlarmHornStrobeConfig | undefined;
  /**
   * The configuration of the animatic for a condenser.
   */
  condenser?: AnimaticCondenserConfig | undefined;
  /**
   * The configuration of the animatic for a control valve.
   */
  controlValve?: AnimaticControlValveConfig | undefined;
  /**
   * The configuration of the animatic for an electric underfloor heater.
   */
  electricUnderfloorHeater?: AnimaticElectricUnderfloorHeaterConfig | undefined;
  /**
   * The configuration of the animatic for an evaporator.
   */
  evaporator?: AnimaticEvaporatorConfig | undefined;
  /**
   * The configuration of the animatic for an exhaust fan.
   */
  exhaustFan?: AnimaticExhaustFanConfig | undefined;
  /**
   * The configuration of the animatic for a gas sensor.
   */
  gasSensor?: AnimaticGasSensorConfig | undefined;
  /**
   * The configuration of the animatic for a heat exchanger.
   */
  heatExchanger?: AnimaticHeatExchangerConfig | undefined;
  /**
   * The configuration of the animatic for a LTU.
   */
  ltu?: AnimaticLTUConfig | undefined;
  /**
   * The configuration of the animatic for a mixing tank.
   */
  mixingTank?: AnimaticMixingTankConfig | undefined;
  /**
   * The configuration of the animatic for a penthouse.
   */
  penthouse?: AnimaticPenthouseConfig | undefined;
  /**
   * The configuration of the animatic for a pump.
   */
  pump?: AnimaticPumpConfig | undefined;
  /**
   * The configuration of the animatic for a reciprocating compressor.
   */
  recipCompressor?: AnimaticRecipCompressorConfig | undefined;
  /**
   * The configuration of the animatic for a remote sump.
   */
  remoteSump?: AnimaticRemoteSumpConfig | undefined;
  /**
   * The configuration of the animatic for a reverse osmosis system.
   */
  reverseOsmosis?: AnimaticReverseOsmosisConfig | undefined;
  /**
   * The configuration of the animatic for a screw compressor.
   */
  screwCompressor?: AnimaticScrewCompressorConfig | undefined;
  /**
   * The configuration of the animatic for a ventilation stack.
   */
  ventilationStack?: AnimaticVentilationStackConfig | undefined;
  /**
   * The configuration of the animatic for a vessel.
   */
  vessel?: AnimaticVesselConfig | undefined;
  /**
   * The configuration of the animatic for a water bath.
   */
  waterBath?: AnimaticWaterBathConfig | undefined;
};

/** @internal */
export const SpecificAnimaticConfig$inboundSchema: z.ZodType<
  SpecificAnimaticConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  "alarm-horn-strobe": types.optional(
    AnimaticAlarmHornStrobeConfig$inboundSchema,
  ),
  condenser: types.optional(AnimaticCondenserConfig$inboundSchema),
  "control-valve": types.optional(AnimaticControlValveConfig$inboundSchema),
  "electric-underfloor-heater": types.optional(
    AnimaticElectricUnderfloorHeaterConfig$inboundSchema,
  ),
  evaporator: types.optional(AnimaticEvaporatorConfig$inboundSchema),
  "exhaust-fan": types.optional(AnimaticExhaustFanConfig$inboundSchema),
  "gas-sensor": types.optional(AnimaticGasSensorConfig$inboundSchema),
  "heat-exchanger": types.optional(AnimaticHeatExchangerConfig$inboundSchema),
  ltu: types.optional(AnimaticLTUConfig$inboundSchema),
  "mixing-tank": types.optional(AnimaticMixingTankConfig$inboundSchema),
  penthouse: types.optional(AnimaticPenthouseConfig$inboundSchema),
  pump: types.optional(AnimaticPumpConfig$inboundSchema),
  "recip-compressor": types.optional(
    AnimaticRecipCompressorConfig$inboundSchema,
  ),
  "remote-sump": types.optional(AnimaticRemoteSumpConfig$inboundSchema),
  "reverse-osmosis": types.optional(AnimaticReverseOsmosisConfig$inboundSchema),
  "screw-compressor": types.optional(
    AnimaticScrewCompressorConfig$inboundSchema,
  ),
  "ventilation-stack": types.optional(
    AnimaticVentilationStackConfig$inboundSchema,
  ),
  vessel: types.optional(AnimaticVesselConfig$inboundSchema),
  "water-bath": types.optional(AnimaticWaterBathConfig$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "alarm-horn-strobe": "alarmHornStrobe",
    "control-valve": "controlValve",
    "electric-underfloor-heater": "electricUnderfloorHeater",
    "exhaust-fan": "exhaustFan",
    "gas-sensor": "gasSensor",
    "heat-exchanger": "heatExchanger",
    "mixing-tank": "mixingTank",
    "recip-compressor": "recipCompressor",
    "remote-sump": "remoteSump",
    "reverse-osmosis": "reverseOsmosis",
    "screw-compressor": "screwCompressor",
    "ventilation-stack": "ventilationStack",
    "water-bath": "waterBath",
  });
});
/** @internal */
export type SpecificAnimaticConfig$Outbound = {
  "alarm-horn-strobe"?: AnimaticAlarmHornStrobeConfig$Outbound | undefined;
  condenser?: AnimaticCondenserConfig$Outbound | undefined;
  "control-valve"?: AnimaticControlValveConfig$Outbound | undefined;
  "electric-underfloor-heater"?:
    | AnimaticElectricUnderfloorHeaterConfig$Outbound
    | undefined;
  evaporator?: AnimaticEvaporatorConfig$Outbound | undefined;
  "exhaust-fan"?: AnimaticExhaustFanConfig$Outbound | undefined;
  "gas-sensor"?: AnimaticGasSensorConfig$Outbound | undefined;
  "heat-exchanger"?: AnimaticHeatExchangerConfig$Outbound | undefined;
  ltu?: AnimaticLTUConfig$Outbound | undefined;
  "mixing-tank"?: AnimaticMixingTankConfig$Outbound | undefined;
  penthouse?: AnimaticPenthouseConfig$Outbound | undefined;
  pump?: AnimaticPumpConfig$Outbound | undefined;
  "recip-compressor"?: AnimaticRecipCompressorConfig$Outbound | undefined;
  "remote-sump"?: AnimaticRemoteSumpConfig$Outbound | undefined;
  "reverse-osmosis"?: AnimaticReverseOsmosisConfig$Outbound | undefined;
  "screw-compressor"?: AnimaticScrewCompressorConfig$Outbound | undefined;
  "ventilation-stack"?: AnimaticVentilationStackConfig$Outbound | undefined;
  vessel?: AnimaticVesselConfig$Outbound | undefined;
  "water-bath"?: AnimaticWaterBathConfig$Outbound | undefined;
};

/** @internal */
export const SpecificAnimaticConfig$outboundSchema: z.ZodType<
  SpecificAnimaticConfig$Outbound,
  z.ZodTypeDef,
  SpecificAnimaticConfig
> = z.object({
  alarmHornStrobe: AnimaticAlarmHornStrobeConfig$outboundSchema.optional(),
  condenser: AnimaticCondenserConfig$outboundSchema.optional(),
  controlValve: AnimaticControlValveConfig$outboundSchema.optional(),
  electricUnderfloorHeater:
    AnimaticElectricUnderfloorHeaterConfig$outboundSchema.optional(),
  evaporator: AnimaticEvaporatorConfig$outboundSchema.optional(),
  exhaustFan: AnimaticExhaustFanConfig$outboundSchema.optional(),
  gasSensor: AnimaticGasSensorConfig$outboundSchema.optional(),
  heatExchanger: AnimaticHeatExchangerConfig$outboundSchema.optional(),
  ltu: AnimaticLTUConfig$outboundSchema.optional(),
  mixingTank: AnimaticMixingTankConfig$outboundSchema.optional(),
  penthouse: AnimaticPenthouseConfig$outboundSchema.optional(),
  pump: AnimaticPumpConfig$outboundSchema.optional(),
  recipCompressor: AnimaticRecipCompressorConfig$outboundSchema.optional(),
  remoteSump: AnimaticRemoteSumpConfig$outboundSchema.optional(),
  reverseOsmosis: AnimaticReverseOsmosisConfig$outboundSchema.optional(),
  screwCompressor: AnimaticScrewCompressorConfig$outboundSchema.optional(),
  ventilationStack: AnimaticVentilationStackConfig$outboundSchema.optional(),
  vessel: AnimaticVesselConfig$outboundSchema.optional(),
  waterBath: AnimaticWaterBathConfig$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    alarmHornStrobe: "alarm-horn-strobe",
    controlValve: "control-valve",
    electricUnderfloorHeater: "electric-underfloor-heater",
    exhaustFan: "exhaust-fan",
    gasSensor: "gas-sensor",
    heatExchanger: "heat-exchanger",
    mixingTank: "mixing-tank",
    recipCompressor: "recip-compressor",
    remoteSump: "remote-sump",
    reverseOsmosis: "reverse-osmosis",
    screwCompressor: "screw-compressor",
    ventilationStack: "ventilation-stack",
    waterBath: "water-bath",
  });
});

export function specificAnimaticConfigToJSON(
  specificAnimaticConfig: SpecificAnimaticConfig,
): string {
  return JSON.stringify(
    SpecificAnimaticConfig$outboundSchema.parse(specificAnimaticConfig),
  );
}
export function specificAnimaticConfigFromJSON(
  jsonString: string,
): SafeParseResult<SpecificAnimaticConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SpecificAnimaticConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SpecificAnimaticConfig' from JSON`,
  );
}
